<div class="root">
    <home-news class="root__column"></home-news>
    <home-notifications class="root__column"></home-notifications>
</div>
